export default "__VITE_ASSET__IfT3y2s9__"